import type { Dispatch, SetStateAction } from "react";

import { Label } from "@/components/field";
import {
  Select,
  SelectButton,
  SelectListBox,
  SelectListItem,
  SelectPopover,
} from "@/components/select";

import { useResolveRoles } from "../../hooks/useResolveRoles";

export function SelectRole({
  role,
  setRole,
}: {
  role: string;
  setRole: Dispatch<SetStateAction<string>>;
}) {
  const { data, isLoading } = useResolveRoles();

  return (
    <Select
      onSelectionChange={(id) => setRole(String(id))}
      placeholder={isLoading ? "Loading..." : "Select a role"}
      selectedKey={role}
    >
      <Label>User role</Label>
      <SelectButton />
      <SelectPopover>
        <SelectListBox
          items={data?.map((role) => ({
            displayName: role.displayName,
            id: role.id.toString(),
          }))}
        >
          {(item) => (
            <SelectListItem id={item.id}>{item.displayName}</SelectListItem>
          )}
        </SelectListBox>
      </SelectPopover>
    </Select>
  );
}
